/* eslint-disable jira/filename-case */
const LOGICEQ = '==' as const;
const LOGICGT = '>' as const;
const LOGICLT = '<' as const;
const LOGICGTE = '>=' as const;
const LOGICLTE = '<=' as const;

export const JsonLogicOperator: {
	readonly EQ: '==';
	readonly GT: '>';
	readonly LT: '<';
	readonly GTE: '>=';
	readonly LTE: '<=';
} = {
	EQ: LOGICEQ,
	GT: LOGICGT,
	LT: LOGICLT,
	GTE: LOGICGTE,
	LTE: LOGICLTE,
} as const;
